import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/AcquisitionBanner.css';

const BANNER_DISMISSED_KEY = 'furever_acquisition_banner_dismissed';

const AcquisitionBanner: React.FC = () => {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(BANNER_DISMISSED_KEY) === 'true'
  );

  if (dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(BANNER_DISMISSED_KEY, 'true');
    setDismissed(true);
  };

  return (
    <div className="acquisition-banner">
      <div className="acquisition-banner-content">
        <span className="acquisition-banner-icon">🎉</span>
        <div className="acquisition-banner-text">
          <strong>Big News!</strong> FurEver has acquired Contoso Pets!
          Shop the <Link to="/products?tags=contoso" className="acquisition-banner-link">Contoso Collection</Link> — clearance prices while supplies last.
        </div>
        <button
          className="acquisition-banner-close"
          onClick={handleDismiss}
          aria-label="Dismiss banner"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default AcquisitionBanner;
